import React from "react";

import fleetcoreAfricanFieldInterfaceControllerBridgeDesktop from "../../images/fleetcore-african-field-interface-controller-bridge-desktop.svg";
import fleetcoreAfricanFieldInterfaceControllerBridgeMobile from "../../images/fleetcore-african-field-interface-controller-bridge-mobile.svg";

import "./FleetCoreAfricanFieldInterface.css";

export default function FleetCoreAfricanFieldInterface() {
  return (
    <section
      className="fleetcore-african-field-interface"
      id="fleetcore-african-field-interface"
      aria-labelledby="fleetcore-african-field-interface-title"
    >
      <div className="fleetcore-african-field-interface__shell">
        <header className="fleetcore-african-field-interface__header">
          <p className="fleetcore-african-field-interface__eyebrow">
            Built for African fleet operations
          </p>
          <h2 id="fleetcore-african-field-interface-title">
            Built for the way African fleets <em>actually work.</em>
          </h2>
          <p>
            In the field, instructions must be obvious. FleetCore behaves like
            the controller already in the group—one clear request at a time,
            with photo-led evidence and visible confirmation.
          </p>
        </header>

        <picture className="fleetcore-african-field-interface__bridge">
          <source
            media="(max-width: 620px)"
            srcSet={fleetcoreAfricanFieldInterfaceControllerBridgeMobile}
          />
          <img
            src={fleetcoreAfricanFieldInterfaceControllerBridgeDesktop}
            alt="WhatsApp conversation converted into a structured FleetCore refuelling record"
            loading="lazy"
          />
        </picture>

        <p className="fleetcore-african-field-interface__result">
          <strong>The driver chats.</strong> FleetCore builds the audit trail.
        </p>
      </div>
    </section>
  );
}
